import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

const MetaData = ({
  title,
  description,
  index = true,
  canonicalUrl,
}: {
  title: string;
  description: string;
  index: boolean;
  canonicalUrl?: Location;
}) => {
  const intl = useIntl();

  const pageTitle =
    title || intl.formatMessage({ id: 'CP_100_META_TITLE_HUBPAGE' });
  const pageDescription =
    description ||
    intl.formatMessage({ id: 'CP_100_META_DESCRIPTION_HUBPAGE' });

  const getCanonicalUrl = () => {
    if (!globalThis.window?.location) return;

    if (window.location.origin && window.location.pathname) {
      return `${window.location.origin}${window.location.pathname}`;
    } else {
      return window.location.href.split('?')[0];
    }
  };

  return (
    <Helmet>
      <title>{pageTitle} | XING</title>
      <meta
        name="robots"
        content={index ? 'index, follow' : 'noindex, follow'}
      />
      <meta name="referrer" content="default" />
      <meta name="description" content={pageDescription} />
      <meta name="twitter:description" content={pageDescription} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:url" content="https://www.xing.com/companies" />
      <meta
        property="og:image"
        content="https://www.xing.com/img/n/xing_icon_apple.png"
      />
      <meta property="og:site_name" content="XING" />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content={'@XING_de'} />

      <link
        rel="shortcut icon"
        href="https://www.xing.com/assets/frontend_minified/img/shared/xing_r1.ico"
        type="image/ico"
      />
      <link
        rel="apple-touch-icon"
        href="https://www.xing.com/assets/frontend_minified/img/shared/xing_icon_apple.png"
      />
      <link
        rel="canonical"
        href={canonicalUrl?.toString() ?? getCanonicalUrl()}
      />
    </Helmet>
  );
};

export { MetaData };
